export default __webpack_public_path__ + "static/media/mobile.8d63b38a.svg";